import useExperiment from 'hooks/common/use-experiment';

/**
 * Hook to handle the test PT-6874 : Tiny Cart
 * @see https://petsdeli.atlassian.net/browse/PT-6874
 */
const useTestPT6874 = () => {
  const { variant, loading } = useExperiment({
    baseEntryId: '3wG9UX9NsEcRTMGCxM9uzY',
  });

  return {
    variant,
    loading,
    showUrgency: variant === 2,
  };
};

export default useTestPT6874;
